import React, { useState } from 'react'
import { makeStyles } from '@mui/styles'
import clsx from 'clsx'
import { times } from 'lodash'
import ThemeInterface from '@/theme-interface'
import lang from '@/lang'

const useStyles = makeStyles((theme: ThemeInterface) => {
  return {
    ratingButton: {
      height: 64,
      width: 64,
      border: theme.border,
      borderRadius: 4,
      backgroundColor: theme.backgroundColor,
      cursor: 'pointer',
      '&:hover': {
        borderColor: theme.primary,
      },
    },
    selected: {
      borderColor: theme.primary,
      backgroundColor: theme.white,
    },
    label: {
      marginTop: 10,
      textAlign: 'center',
      color: theme.black,
      fontSize: theme.fontSizes.tiny,
    },
    ratingContainer: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    descriptionWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
    },
  }
})

interface RatingProps {
  maxRating?: number;
  onRatingSelected?: (rating: number) => void;
}

const Rating: React.FC<RatingProps> = ({
  maxRating = 5,
  onRatingSelected,
}) => {
  const [selectedRating, setSelectedRating] = useState<number | null>(null)

  const classes = useStyles()

  const handleRating = (rating: number) => {
    setSelectedRating(rating)
    onRatingSelected && onRatingSelected(rating)
  }

  return (
    <div>
      <div className={classes.ratingContainer}>
        {times(maxRating).map((_, index) => {
          const ratingValue = index + 1
          return (
            <button
              key={ratingValue}
              className={clsx(classes.ratingButton, selectedRating === ratingValue ? classes.selected : '')}
              onClick={() => handleRating(ratingValue)}
            >
              {ratingValue}
            </button>
          )
        })}
      </div>
      <div className={classes.descriptionWrapper}>
        <div className={classes.label}>
          {lang.csat.rating.unsatisfied}
        </div>
        <div className={classes.label}>
          {lang.csat.rating.satisfied}
        </div>
      </div>
    </div>
  )
}

export default Rating
